module.exports = __webpack_public_path__ + "images/FUSA_icons/042-online-shop-7.8a3375b70ac2215b7c9430aa85166d1c.svg";